module.exports = __webpack_public_path__ + "media/images/shared/icon_tips_white-282604f7aa2355c146e15e8f032c6d77.png";